const PostTime = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3346 9.99984C18.3346 14.6022 14.6037 18.3332 10.0013 18.3332C5.39893 18.3332 1.66797 14.6022 1.66797 9.99984C1.66797 5.39746 5.39893 1.6665 10.0013 1.6665C14.6037 1.6665 18.3346 5.39746 18.3346 9.99984Z" fill="#A1A1A1"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M10.0013 6.0415C10.3465 6.0415 10.6263 6.32133 10.6263 6.6665V9.74095L12.5266 11.6412C12.7707 11.8853 12.7707 12.281 12.5266 12.5251C12.2825 12.7692 11.8868 12.7692 11.6427 12.5251L9.55936 10.4418C9.44215 10.3246 9.3763 10.1656 9.3763 9.99984V6.6665C9.3763 6.32133 9.65612 6.0415 10.0013 6.0415Z" fill="white"/>
        </svg>
    )
}

export default PostTime